import { Button } from '../../../common/components/button/Button'
import { LinkButton, NavLinkButton } from '../../../common/components/button/LinkButton'
import { getIcon } from '../../../common/components/icons/utils'
import { HELP_MENU_CONTROL_ID, useHelpMenu } from '../../../contexts/HelpMenuContextProvider'
import { useUser } from '../../../contexts/userContext'
import { useParams } from 'react-router-dom'
import { WelcomeBlockButton } from '../helpers'
import { getClientInfo } from '../../../util/browserSpecifics'

type BannerButtonProps = {
  button: WelcomeBlockButton
  language?: string
  isSecondary?: boolean
}

export const BannerButton: React.FC<BannerButtonProps> = ({ button, language, isSecondary }) => {
  const { toggleDisplayMenu } = useHelpMenu()
  const { user } = useUser()
  const { gameId: gameIdParam } = useParams()

  const handleContactSupportClick = () => {
    if (!window.Beacon) {
      console.warn('HelpScout Beacon is not available')
      return
    }

    const clientInfo = getClientInfo()

    window.Beacon('identify', {
      name: user?.contactName,
      email: user?.email,
      'business-id': user?.activeBusiness.id,
			industry: user?.activeBusiness.industry,
      'game-id': gameIdParam,
      company: user?.activeBusiness.name,
      'browser-name': clientInfo.browser,
      'device-type': clientInfo.deviceType,
      platform: clientInfo.platform,
      'user-agent': clientInfo.userAgent,
    })

    window.Beacon('open')
  }

  switch (button.type) {
    case 'link-external':
      return (
        <LinkButton
          iconName={button.icon}
          href={language === 'fi' ? button.linkFinnish || button.link : button.link}
          label={button.label}
          target='_blank'
          rel='noreferrer'
        />
      )
    case 'link-internal':
      return <NavLinkButton label={button.label} iconName={button.icon} route={button.link!} />
    case 'toggle-help':
      return (
        <Button
          style={{
            letterSpacing: '0.06em',
            width: 'fit-content',
          }}
          variant={isSecondary ? 'outline-normal' : 'normal'}
          onClick={toggleDisplayMenu}
          id={`${HELP_MENU_CONTROL_ID}__trialMessage${isSecondary ? 'Secondary' : 'Primary'}Button`}
        >
          {button.icon && <span className='iconWrapperBig'>{getIcon(button.icon)}</span>}
          {button.label}
        </Button>
      )
    case 'ninchat-form':
      return (
        <Button
          style={{
            letterSpacing: '0.06em',
            width: 'fit-content',
          }}
          variant={isSecondary ? 'outline-normal' : 'normal'}
          onClick={handleContactSupportClick}
          id={`${HELP_MENU_CONTROL_ID}__trialMessage${isSecondary ? 'Secondary' : 'Primary'}Button`}
        >
          {button.icon && <span className='iconWrapperBig'>{getIcon(button.icon)}</span>}
          {button.label}
        </Button>
      )
    default:
      return null
  }
}
